/** 한 번의 목록 조회 동안 같은 Firestore 읽기를 진행 중인 Promise부터 공유한다. */
export const createFirestoreReadCache = <Document, Collection>(readers: {
    readFirestoreOneDoc: (path: string, id: string) => Promise<Document>;
    readFirestore: (path: string) => Promise<Collection>;
}) => {
    const documents = new Map<string, Promise<Document>>();
    const collections = new Map<string, Promise<Collection>>();

    return {
        readFirestoreOneDoc: (path: string, id: string) => {
            const key = `${path}/${id}`;
            if (!documents.has(key)) {
                documents.set(key, readers.readFirestoreOneDoc(path, id));
            }
            return documents.get(key)!;
        },
        readFirestore: (path: string) => {
            if (!collections.has(path)) {
                collections.set(path, readers.readFirestore(path));
            }
            return collections.get(path)!;
        },
    };
};
